import React, { useEffect } from 'react';
import { PrimaryButton } from '@workday/canvas-kit-react/button';
import styles from './error-page.module.scss';
import { useHistory, useLocation } from 'react-router-dom';
import { FAQ_PATH, LOGIN_PATH } from '../../react-router-paths';
import { Trans, useTranslation } from 'react-i18next';
import { autoId, ExternalLink } from '@workday/upc-common';
import { ID_BACK_TO_SIGN_IN, ID_ERROR_PAGE_SUBJECT } from '../../autoIds';

export const UNAUTH_FLOW = 'unauthenticated flow';

export function ErrorPage() {
    const history = useHistory();

    const { t } = useTranslation('shared');

    function onSignInClick() {
        history.push(LOGIN_PATH);
    }

    const location = useLocation<{ context: 'unauthenticated flow' }>();
    const context = location.state !== null ? location.state.context : null;

    useEffect(() => {
        if (context == null) {
            history.replace(LOGIN_PATH);
        }
    }, [history, context]);

    return (
        <div className={styles.resetPasswordEmailEntry}>
            <h1 className={styles.title} {...autoId(ID_ERROR_PAGE_SUBJECT)}>
                {t(context === UNAUTH_FLOW ? 'ErrorPage.unableToVerifyIdentity' : 'ErrorPage.youHaveBeenSignedOut')}
            </h1>
            <p className={styles.body}>
                <Trans i18nKey={'ErrorPage.unableToVerifyIdentityDesc'}>
                    We were unable to verify your identity with the information provided. For additional help visit our
                    <ExternalLink href={FAQ_PATH}>FAQ</ExternalLink>
                    page.
                </Trans>
            </p>
            <PrimaryButton onClick={onSignInClick} size='large' grow={true} {...autoId(ID_BACK_TO_SIGN_IN)}>
                {t(context === UNAUTH_FLOW ? 'ErrorPage.backToSignIn' : 'ErrorPage.submitButton')}
            </PrimaryButton>
        </div>
    );
}
